export default __webpack_public_path__ + "09dd7b3ae11ea32a5eec319e078a8ce2.png";